import React from 'react';
import { getIn } from 'formik';
import Select from 'react-select';

import { get } from 'buyside/util/lodashAltJs';

import fieldStyles from '../fieldStyles';

const InputField = ({
  field,
  form: { dirty, touched, errors, isSubmitting, setFieldValue, setFieldTouched },
  ...props
}) => {
  const {
    type,
    label,
    addon,
    note,
    options,
    placeholder,
    required = true,
    customStyles,
    selectOptionsFormat = option => ({ value: option, label: option }),
    autoComplete,
    analyticsTag,
    disabled
  } = props;
  const datePlaceholder = type === 'date' ? 'yyyy-mm-dd' : '';
  const InputTag = type === 'textarea' ? 'textarea' : 'input';
  const value = field.value || field.value === 0 ? field.value : '';
  const isTouched = getIn(touched, field.name);
  const error = getIn(errors, field.name);
  const styles = customStyles ? customStyles : fieldStyles;

  let selectOptions;
  if (type === 'select') selectOptions = options.map(selectOptionsFormat);

  return (
    <div className={styles.fieldContainer}>
      <label className={styles.fieldContainerLabel}>
        <div className={styles.fieldLabel}>{label}</div>
        <div className={`input-group ${styles.inputFieldGroup}`}>
          {type !== 'select' && (
            <InputTag
              {...field}
              type={type}
              className={`form-control ${styles.input} ${addon && styles.withAddon}`}
              value={value}
              disabled={isSubmitting || disabled}
              placeholder={placeholder || datePlaceholder}
              autoComplete={autoComplete}
              data-heap={analyticsTag}
            />
          )}
          {type === 'select' && (
            <Select
              classNamePrefix="Select"
              menuShouldScrollIntoView={false}
              isSearchable={props.searchable}
              onChange={selectedOption => {
                setFieldValue(field.name, get(selectedOption, 'value'));
              }}
              onBlur={() => setFieldTouched(field.name)}
              isClearable={!required}
              options={selectOptions}
              placeholder={placeholder}
              isDisabled={isSubmitting || disabled}
              styles={{
                container: (baseStyles, props) => ({
                  ...baseStyles,
                  fontSize: '14px',
                  letterSpacing: 'normal',
                  zIndex: props.isFocused ? '200' : ''
                })
              }}
              value={selectOptions.filter(option => option.value === field.value)}
            />
          )}
          {addon && <span className="input-group-addon">{addon}</span>}
        </div>
      </label>
      {(isTouched || dirty) && error && <div className={styles.fieldError}>{error}</div>}
      {note && <div className={styles.fieldNote}>{note}</div>}
    </div>
  );
};

export default InputField;
